module.exports = __webpack_public_path__ + "img/46.092a840e.png";